'use client';

import {
  TopNavigation,
  TopNavigationProps,
} from '@pickleballinc/ui/components/global/TopNavigation';

export const TopNavigationWrapper = (props: TopNavigationProps) => {
  return <TopNavigation {...props} onSSOClick={undefined} />;
};
